module.exports = __webpack_public_path__ + "img/24_52.0440e7ac.png";